import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { NotificationProvider } from './context/NotificationContext';
import { APP_VERSION, APP_VERSION_STORAGE_KEY } from './config/constants';
import AppRoutes from './routes';

function App() {
  useEffect(() => {
    const stored = localStorage.getItem(APP_VERSION_STORAGE_KEY);
    if (stored !== APP_VERSION) {
      localStorage.setItem(APP_VERSION_STORAGE_KEY, APP_VERSION);
      if (stored != null) {
        window.location.reload();
      }
    }
  }, []);

  return (
    <AuthProvider>
      <NotificationProvider>
        <Router>
          <AppRoutes />
        </Router>
      </NotificationProvider>
    </AuthProvider>
  );
}

export default App;
